import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@parrot-software/design-system';
import { CircleAlert } from '@parrot-software/design-system/icons';
import { cn } from '@parrot-software/utils';
import { CustomerStates } from '@subscriptions/domain/types/SubscriptionsConst';
import { useSubscriptionBlocks } from '@subscriptions/presentation/hooks';

type RemainingChurnedAlertProps = {
  reactivatedBlockUuid: string;
};

/** Warns that other subscriptions are still churned, each with its own charge. */
export const RemainingChurnedAlert = ({ reactivatedBlockUuid }: RemainingChurnedAlertProps) => {
  const { t } = useTranslation('subscriptions');
  const { data: blocks } = useSubscriptionBlocks();

  const count = (blocks ?? []).filter(
    (block) => block.uuid !== reactivatedBlockUuid && block.customerState === CustomerStates.INACTIVE,
  ).length;

  if (count === 0) {
    return null;
  }

  return (
    <Alert
      className={cn(
        'flex w-full max-w-[500px] items-start gap-3 rounded-lg bg-destructive/10 font-sans',
        '[&>svg]:relative [&>svg]:left-auto [&>svg]:top-auto [&>svg+div]:translate-y-0 [&>svg~*]:pl-0',
      )}
      variant="destructive"
    >
      <CircleAlert className="mt-0.5 h-4 w-4 shrink-0" />
      <AlertDescription className="text-sm font-medium">
        <strong className="font-bold">
          {t('blockCreationWizard.confirmation.paymentDone.remainingChurned', { count })}
        </strong>{' '}
        {t('blockCreationWizard.confirmation.paymentDone.remainingChurnedDetail', { count })}
      </AlertDescription>
    </Alert>
  );
};
